import { Facebook } from '@core/models';
import { makeQuery } from '@core/queries/types';

type Output = {
  businessInstagramUserDetail: Facebook.FacebookInstagramAccountOutput;
};

export const businessInstagramUserDetail = makeQuery<Output>(`
query BusinessInstagramUserDetail {
  facebook {
    businessInstagramUserDetail {
      id
      name
      profilePictureUrl
      followCount
      followedByCount
    }
  }
}
`);
